<infigo-detail-block>
	<app-skeleton [height]="'200px'" [loading]="loading">
		<n-tab
            [(activeItem)]="defaultActiveItem"
            [type]="'card'"
            style="height: calc(100% - 0.33rem)"
        >
            <n-tab-item [header]="firstTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-member-host-table #memberHostTable [data]="hostList" [loading]="updateLoading"></app-member-host-table>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
            <n-tab-item [header]="secondTabItem">
				<ng-template nTemplate>
					<div class="table-layout">
						<div class="table-container">
                            <app-mapping-table #mappingTable [data]="mappingList" [loading]="updateLoading" [type]="'hostGroup'"></app-mapping-table>
						 </div>
					</div>
				</ng-template>
            </n-tab-item>
		</n-tab>
	</app-skeleton>
</infigo-detail-block>
